import type { SVGProps } from "react";

/**
 * chevron-large-left, chev left, last
 * @category Arrows
 */
export default function IconChevronLargeLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M14.2498 21.25L9.35759 13.0222C8.98302 12.3922 8.98302 11.6078 9.35759 10.9779L14.2498 2.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
